import { useEffect } from 'react';
import { usePublisherStore } from '.';

function usePublisherInit() {
    const publisherStore = usePublisherStore();

    useEffect(() => {
        publisherStore.getFeaturedPublishers();
        publisherStore.getWhatshotPublishers();
        publisherStore.getPopularNowPublishers();
        publisherStore.getNearMePublishers();
        publisherStore.getRecommendedPublishers();
        publisherStore.getDirectoryPublishers();
    }, []);
}

export default usePublisherInit;
